import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import requestAccount from "./requestAccount";
import student from "./student";
import teacher from "./teacher";
import course from "./course";
import scheduleCourse from "./scheduleCourse";
import schedule from "./schedule";
import clazz from "./clazz";
import payment from "./payment";
import permissionAndRoles from "./permissionAndRoles";
import assignment from "./assignment";

const rootReducer = combineReducers({
  auth,
  message,
  requestAccount,
  student,
  teacher,
  course,
  scheduleCourse,
  schedule,
  clazz,
  payment,
  permissionAndRoles,
  assignment
});

export default rootReducer;
